import styled from 'styled-components';

export const SizeButton = styled.div.attrs(props => ({
    width:props.width || 32,
    height:props.height || 32,
    borderRadius:props.borderRadius || 4,
    zIndex:props.zIndex || 550,
}))`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index:${props => props.zIndex};
    width:${props => `${props.width}px`};
    height:${props => `${props.height}px`};
    border-radius:${props => `${props.borderRadius}px`};
    transition: all 0.2s ease-in-out ;
    opacity: 0.45;
    cursor: pointer;
    &:hover {
        transition: all 0.2s ease-in-out;
        opacity:0.8;
        background-color: rgba(0,0,0,0.15)
    }
    &:hover span {
        visibility: visible;
    }
`;